import dayjs from 'dayjs';

import { User } from '../../../../graphql/API';
import { Action, State } from './types';

export const initialState = (users: User[]): State => ({
  step: 0,
  users,
  startTime: dayjs().hour(9).minute(0).second(0),
  endTime: dayjs().hour(18).minute(0).second(0),
});

export const reducer = (state: State, action: Action) => {
  switch (action.type) {
    case 'next': {
      return {
        ...state,
        ...action.payload,
        step: Math.min(Math.max(state.step + 1, 0), 4),
      };
    }
    case 'prev':
      return {
        ...state,
        step: Math.max(Math.min(state.step - 1, 4), 0),
      };
    case 'update':
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
